import { createContext } from "react";
import type { HydratedUser } from "@packsize/identity-api-sdk";

import type { LicenseTier } from "../../schemas";
import type { LicensedProductCategoryName } from "../../types";

interface UserContextProps {
	currentUser: HydratedUser | null | undefined;
	isPacksizeUser: boolean | undefined;
	isPacksizePartner: boolean | undefined;
	hasAnyRole: (roles: string[]) => boolean | undefined;
	hasLicense: (
		product: LicensedProductCategoryName,
		tier: LicenseTier,
		licenseFeatureFlag?: string | string[],
	) => boolean | undefined;
	refreshUser: () => Promise<void>;
	setUser: (user: HydratedUser) => void;
}

const initialState: UserContextProps = {
	currentUser: undefined,
	isPacksizeUser: undefined,
	isPacksizePartner: undefined,
	hasAnyRole: () => undefined,
	hasLicense: () => undefined,
	refreshUser: () => Promise.resolve(),
	setUser: () => undefined,
};

export const UserContext = createContext<UserContextProps>(initialState);
